// extracted by mini-css-extract-plugin
export default {"header":"Table_header__QgrfU","link":"Table_link__1Jx11","active":"Table_active__8TpNa","inactive":"Table_inactive__M-o3P"};